
.root {
    flex: 1;
    padding: 3mm 7mm;
    /* layout */
    --minimap-size: 17mm;
    --map-width: 70mm;
    --qr-code-size: 15mm;
    display: grid;
    grid-template-columns: var(--minimap-size) calc(var(--map-width) - var(--minimap-size)) auto var(--minimap-size);
    grid-template-rows: var(--minimap-size) auto 8mm;
    grid-template-areas:
            "minimap header header number"
            "map map addresses addresses"
            "footer footer footer footer";
}

.header {
    grid-area: header;
    align-self: center;
}

.title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
}

.region {
    text-align: center;
    font-size: 16px;
}

.number {
    grid-area: number;
    align-self: center;
    justify-self: end;
    font-size: 30px;
    font-weight: bold;
    white-space: nowrap;
}

.minimap {
    grid-area: minimap;
    margin-bottom: 0.6mm;
}

.map {
    grid-area: map;
}

.minimap canvas, .map canvas {
    border-radius: 2mm;
}

.addresses {
    grid-area: addresses;
    white-space: pre-line;
    margin-left: 5mm;
    /* I can't figure out a way to vertically align the text when the QR code is present,
       so let's just have an empty row at the top to make the text tidier when the address
       has only one or two lines of text. */
    padding-top: 1.3em; /* the decimal is fine-tuned to have only a small gap between QR code and the text above it */
}

.footer {
    grid-area: footer;
    padding-top: 3mm;
    text-align: center;
    font-size: 9px;
    font-weight: bold;
    white-space: pre-line;
}

.qrCode {
    float: right; /* shape-outside only applies to floating items */
    height: 100%; /* take all height */
    width: var(--qr-code-size);
    margin-left: 0.5mm;

    /* push the image to the bottom */
    display: flex;
    align-items: flex-end;

    /* make the text flow around the image */
    shape-outside: inset(calc(100% - var(--qr-code-size)) 0 0 0);
}

.qrCode > svg {
    width: 100%;
    height: auto;
}
